module.exports = __webpack_public_path__ + "img/send-offer-desktop-en.b0f54dc7.jpg";